import React from "react";

import "./styles/main.scss";
// import "@formatic/theme-transformd/src/main.scss";
import logo from "./img/logo.jpg";

const ClickFinanceLayout = ({ children }) => (
  <div className="layout-click-finance">
    <header>
      <div className="container">
        <a href="/">
          <img src={logo} alt="Spire Capital" className="logo" />
        </a>
        <ul className="menu menu-nopadding">
          <li>
            <h1>Atlas High Income Property Fund - Application</h1>
          </li>
        </ul>

        <ul className="menu login">
          <li>
            <a href="mailto:atlas@oneregistryservices.com.au">
              atlas@oneregistryservices.com.au
            </a>
          </li>
          <li>
            <a href="tel:02 8304 5190">+61 (02) 83045190</a>
          </li>
        </ul>
      </div>
    </header>
    <div className="banner" />
    <div className="container">
      <main className="content">{children}</main>
    </div>
  </div>
);

export default ClickFinanceLayout;
